require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-reflections-on-international-womens-day-2019-mdbs-asia.json") })
        }
      }, "path---en-us-update-reflections-on-international-womens-day-2019-mdbs-asia");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-reflections-on-international-womens-day-2019-mdbs-asia!./.cache/json/en-us-update-reflections-on-international-womens-day-2019-mdbs-asia.json
// module id = 788
// module chunks = 231608221292675